import React, { useEffect, useRef, useState } from 'react';
import { Container, Form, Button, Row, Col, Card, ListGroup } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import './RequestForApproval.css';
import ApprovalProcessService from '../services/ApprovalProcessService';
import { toast } from 'react-toastify';
import { useLoading } from '../Utils/LoadingContext';
import showToast from "../Utils/ToastContainer";
import { FaTrash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useWarning } from '../Utils/WarningContext';
import Select from 'react-select';

const RequestForApproval = () => {
  const navigate = useNavigate();
  const editorRef = useRef(null);
  const editorInstance = useRef(null);
  const { setLoading } = useLoading();

  const [approvalType, setapprovalType] = useState([]);
  const [errors, setErrors] = useState({});
  const { warningMessage } = useWarning();

  const [formData, setFormData] = useState({
    Title: '',
    ApprovalTypeId: '',
    RequestId: '',
    Description: '',
    Approver: '',
    Attachments: [],
  });

  const [selectedRequestId, setSelectedRequestId] = useState('');
  const [selectedRequests, setSelectedRequests] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [attachmentError, setAttachmentError] = useState('');

  const companyName = localStorage.getItem('compantName') || "Company";
  const departmentName = localStorage.getItem('departmentName') || "Department";

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(selectedRequests);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setSelectedRequests(items); // update the state with new order
  };

  const handleFileChange = (e) => {
    const newFiles = Array.from(e.target.files);
    const validExtensions = ["png", "jpg", "jpeg", "pdf", "xls", "xlsx"];
    const validFiles = [];
    const invalidFiles = [];

    newFiles.forEach((file) => {
      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (validExtensions.includes(fileExtension)) {
        validFiles.push(file);
      } else {
        invalidFiles.push(file.name);
      }
    });

    if (invalidFiles.length > 0) {
      const errorMessage = `Only PNG, JPG, JPEG, PDF, XLS, XLSX files are allowed. Invalid: ${invalidFiles.join(', ')}`;
      toast.error(errorMessage, { autoClose: 5000 });
      setAttachmentError(errorMessage);
    } else {
      setAttachmentError('');
    }

    // Append new valid files to existing attachments
    setAttachments((prevFiles) => [...prevFiles, ...validFiles]);

    // Reset the file input to allow re-selecting the same file again
    e.target.value = null;
  };



  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "Title") {
      if (value.length > 50) return; // Prevent input beyond 50 chars
    }

    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({ ...errors, [name]: '' });
  };

  useEffect(() => {
    if (editorRef.current && !editorInstance.current) {
      window.ClassicEditor.create(editorRef.current)
        .then(editor => {
          editorInstance.current = editor;
        })
        .catch(error => {
          console.error('Error initializing CKEditor:', error);
        });
    }

    const fetchDropdownData = async () => {
      try {
        setLoading(true);
        const approvalTypeResponse = await ApprovalProcessService.getDropDownListData(2);

        if (approvalTypeResponse.success) setapprovalType(approvalTypeResponse.data.result);

        setLoading(false);
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
        setLoading(false);
      }
    };
    fetchDropdownData();

    return () => {
      if (editorInstance.current) {
        editorInstance.current.destroy();
        editorInstance.current = null;
      }
    };
  }, []);

  const handleClear = () => {
    setFormData({
      Title: '',
      ApprovalTypeId: '',
      RequestId: '',
      Description: '',
      Approver: '',
      Attachments: [],
    });
    setSelectedRequests([]);
    setSelectedRequestId('');
    if (editorInstance.current) {
      editorInstance.current.setData('');
    }
    setErrors({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const descriptionValue = editorInstance.current?.getData().trim() || '';
    const updatedFormData = {
      ...formData,
      Description: descriptionValue,
    };

    const isValid = validateForm(descriptionValue);

    if (isValid) {
      setLoading(true);
      try {

        const approverIds = selectedRequests.map((approver) => approver.id);
        const formDataToSend = new FormData();
        formDataToSend.append('title', updatedFormData.Title);
        formDataToSend.append('lCType', Number(updatedFormData.ApprovalTypeId));
        formDataToSend.append('lCDescription', descriptionValue);
        formDataToSend.append('stageId', 1);
        approverIds.forEach(id => {
          formDataToSend.append('approverIds', id);
        });

        // Add each attachment
        attachments.forEach((file, index) => {
          formDataToSend.append(`attachments`, file);
        });

        const response = await ApprovalProcessService.CreateApproval(formDataToSend);

        if (response.data.statusCode === 200) {
          setLoading(false);
          handleClear();
          showToast("Your Request hab been raised successfully.", 'success', { autoClose: 700 });
          navigate("/home");
        } else {
          toast.error('Failed to approve. Please try again.');
          setLoading(false);
        }
      } catch (error) {
        toast.error('An error occurred while submitting the form.');
        console.error('Submission Error:', error);
        setLoading(false);
      }
    }
  };

  const validateForm = (descriptionValue) => {
    let tempErrors = {};
    let isValid = true;

    Object.keys(formData).forEach((field) => {
      if (field !== 'Description' && field !== 'Approver' && field !== 'RequestId' && !formData[field]) {
        tempErrors[field] = 'This field is required';
        isValid = false;
      }
    });

    const strippedDescription = descriptionValue.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim();
    if (!strippedDescription) {
      tempErrors.Description = 'Description is required';
      isValid = false;
    }

    if (selectedRequests.length === 0) {
      tempErrors.Approver = 'Please select at least one approver';
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  const handleAddRequest = async () => {
    
    if (selectedRequestId && !selectedRequests.some(req => req.id === selectedRequestId.id)) {
      setSelectedRequests([...selectedRequests, selectedRequestId]);
      setSelectedRequestId('');
      setErrors(prevErrors => {
        const newErrors = { ...prevErrors };
        delete newErrors.Approver;
        return newErrors;
      });
    }
  };

  const handleRemoveRequest = (id) => {
    setSelectedRequests(selectedRequests.filter(item => item.id !== id));
  };

  // 🔍 Load Approver options dynamically
  const loadApproverOptions = async (inputValue) => {
    if (!inputValue || inputValue.trim() === "") return [];

    try {

      const response = await ApprovalProcessService.getApproverDropDownListData(inputValue);
      if (response.success) {
        return response.data.result.map(item => ({
          value: item.id,
          label: item.name,
          id: item.id,
          name: item.name
        }));
      }
    } catch (error) {
      console.error("Error loading approver options:", error);
    }
    return [];
  };



  return (
    <Container className="mt-5 request-form">
      <h6 className="fw-bold text-primary mb-2">Request for Approval</h6>
      <Card className="p-4 shadow-sm">
        <Form onSubmit={handleSubmit}>

          {/* Approval Type, Subject Line, Company in one row */}
          <Row className="mb-3 align-items-end">
            <Col md={4}>
              <Form.Group controlId="ApprovalTypeId">
                <Form.Label>Approval Type</Form.Label>
                <Select
                  name="ApprovalTypeId"
                  options={approvalType.map(item => ({
                    value: item.id,
                    label: item.name
                  }))}
                  placeholder="Select Approval Type"
                  value={approvalType.find(item => item.id === formData.ApprovalTypeId) ? {
                    value: formData.ApprovalTypeId,
                    label: approvalType.find(item => item.id === formData.ApprovalTypeId).name
                  } : null}
                  onChange={(selectedOption) =>
                    handleChange({
                      target: {
                        name: 'ApprovalTypeId',
                        value: selectedOption ? selectedOption.value : ''
                      }
                    })
                  }
                  className={errors.ApprovalTypeId ? 'is-invalid' : ''}
                  styles={{
                    control: (base) => ({
                      ...base,
                      height: 32, // Basic height
                      minHeight: 32,
                    }),
                    dropdownIndicator: (base) => ({
                      ...base,
                      paddingTop: 2,
                      paddingBottom: 2
                    }),
                    clearIndicator: (base) => ({
                      ...base,
                      paddingTop: 2,
                      paddingBottom: 2
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      paddingTop: 0,
                      paddingBottom: 0
                    })
                  }}
                />

                <div style={{ minHeight: '1.25rem', marginTop: '0.25rem' }}>
                  {errors.ApprovalTypeId && (
                    <div className="invalid-feedback d-block">{errors.ApprovalTypeId}</div>
                  )}
                </div>
              </Form.Group>
            </Col>

            <Col md={4} className="position-relative">
              <Form.Group controlId="Title" className="mb-0">
                <Form.Label>Subject Line</Form.Label>
                <Form.Control
                  type="text"
                  name="Title"
                  placeholder="Enter title"
                  maxLength={50}
                  className={`form-control ${errors.Title ? 'is-invalid' : ''}`}
                  value={formData.Title}
                  onChange={handleChange}
                />
              </Form.Group>

              {/* Reserve space for character count and error message */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginTop: '0.25rem',
                  fontSize: '0.75rem',
                  minHeight: '1.25rem',
                }}
              >
                <div style={{ color: '#6c757d' }}>
                  {50 - formData.Title.length} characters left
                </div>
                <div style={{ color: 'red' }}>
                  {errors.Title && <span>{errors.Title}</span>}
                </div>
              </div>
            </Col>


            <Col md={4}>
              <Form.Group>
                <Form.Label>Company</Form.Label>
                <div className="form-control bg-light">{companyName}</div>
                {/* Reserve empty space to keep height consistent */}
                <div style={{ minHeight: '1.25rem', marginTop: '0.25rem' }}></div>
              </Form.Group>
            </Col>
          </Row>


          {/* Department and Approver Stage in one row */}
          <Row className="mb-3 align-items-end">
            <Col md={4}>
              <Form.Group className="mb-0">
                <Form.Label>Department</Form.Label>
                <div
                  className="form-control bg-light d-flex align-items-center"
                  style={{
                    pointerEvents: 'none',
                    height: '38px',
                    minWidth: '100%',
                  }}
                >
                  {departmentName}
                </div>
              </Form.Group>
            </Col>

            <Col md={5}>
              <Form.Group className="mb-0">
                <Form.Label>Approver Stage</Form.Label>
                <AsyncSelect
                  cacheOptions
                  loadOptions={loadApproverOptions}
                  defaultOptions
                  value={selectedRequestId}
                  onChange={(option) => setSelectedRequestId(option)}
                  placeholder="Search Approver By Name.."
                  isClearable
                  className="basic-single"
                  classNamePrefix="select"
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      minHeight: '38px',
                      height: '38px',
                    }),
                    valueContainer: (provided) => ({
                      ...provided,
                      height: '38px',
                      padding: '0 6px',
                    }),
                    input: (provided) => ({
                      ...provided,
                      margin: '0px',
                    }),
                    indicatorsContainer: (provided) => ({
                      ...provided,
                      height: '38px',
                    }),
                  }}
                />
                {errors?.Approver && (
                  <div className="invalid-feedback d-block">{errors.Approver}</div>
                )}
              </Form.Group>
            </Col>

            <Col md={3}>
              <Button
                variant="success"
                onClick={handleAddRequest}
                disabled={!selectedRequestId}
                style={{ width: '100px', height: '38px', marginTop: '8px' }}
              >
                Add
              </Button>
            </Col>
          </Row>

          {/* Selected Requests */}
          {selectedRequests.length > 0 && (
            <Row className="mb-3">
              <Col>
                <DragDropContext onDragEnd={handleOnDragEnd}>
                  <Droppable droppableId="stages">
                    {(provided) => (
                      <ListGroup {...provided.droppableProps} ref={provided.innerRef}>
                        {selectedRequests.map((item, index) => (
                          <Draggable key={item.id} draggableId={item.id.toString()} index={index}>
                            {(provided) => (
                              <ListGroup.Item
                                className="d-flex justify-content-between align-items-center"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <div>Stage {index + 1} - {item.name}</div>
                                <Button variant="danger" size="sm" onClick={() => handleRemoveRequest(item.id)}>
                                  <FaTrash />
                                </Button>
                              </ListGroup.Item>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </ListGroup>
                    )}
                  </Droppable>
                </DragDropContext>
              </Col>
            </Row>
          )}

          {/* Description */}
          <Row className="mb-3">
            <Col xs={12}>
              <Form.Group controlId="Description">
                <Form.Label>Description</Form.Label>
                <textarea
                  ref={editorRef}
                  className={`form-control ckeditor ${errors.Description ? 'is-invalid' : ''}`}
                  name="Description"
                  rows={8}
                ></textarea>
                {errors.Description && <div className="invalid-feedback">{errors.Description}</div>}
              </Form.Group>
            </Col>
          </Row>

          {/* Attachments */}
          <Row className="mb-3">
            <Col>
              <Form.Group controlId="attachments">
                <Form.Label>Attachments (Optional)</Form.Label>
                <Form.Control
                  type="file"
                  multiple
                  onChange={handleFileChange}
                  isInvalid={!!attachmentError}
                />
                {attachmentError && (
                  <Form.Text className="text-danger">{attachmentError}</Form.Text>
                )}
              </Form.Group>

              <div className="mt-2">
                {attachments.map((file, index) => (
                  <div key={index} className="d-flex align-items-center gap-2 mb-1">
                    <i className="bi bi-paperclip text-secondary"></i>
                    <span>{file.name}</span>
                  </div>
                ))}
              </div>
            </Col>
          </Row>

          {/* Submit Button */}
          {!warningMessage && (
            <Button variant="primary" type="submit" className="w-100 mt-3">
              Submit
            </Button>
          )}

        </Form>
      </Card>
    </Container>
  );

};

export default RequestForApproval;
